import { gql } from '@apollo/client';

export const COMMON_ASSET_FIELDS = gql`
  fragment CommonAssetFields on Asset {
    id
    url
    blurhash
  }
`;

export const GET_TAGS = gql`
  query tagsAdmin($filter: TagsFilter) {
    tagsAdmin(filter: $filter) {
      count
      tags {
        id
        name
      }
    }
  }
`;

export const GET_TOPICS = gql`
  query topicsAdmin($filter: TopicsFilter) {
    topicsAdmin(filter: $filter) {
      count
      topics {
        id
        name
        primaryColor
      }
    }
  }
`;

export const GET_VIDEO = gql`
  ${COMMON_ASSET_FIELDS}
  query videoAdmin($id: ID!) {
    videoAdmin(where: { id: $id }) {
      title
      description
      slug
      tags {
        id
        name
      }
      topics {
        id
        name
      }
      allowedPlans {
        key
        expiredAt
      }
      isLive
      liveStatus
      liveInfo {
        endDate
        startDate
        timezone
      }
      status
      contentRating
      autoPublishAt
      displayDate
      metaHeader
      metaFooter
      video: videoAsset {
        id
        serviceVideoThumbnail
        serviceImageThumbnail
      }
      image {
        ...CommonAssetFields
      }
      imageThumbnail {
        ...CommonAssetFields
      }
      videoThumbnail {
        ...CommonAssetFields
      }
      timelineThumbnail {
        ...CommonAssetFields
      }
      documents {
        ...CommonAssetFields
        title
      }
      audioTracks {
        ...CommonAssetFields
        title
        serviceImageThumbnail
      }
      textTracks {
        ...CommonAssetFields
        title
      }
      html
      resources {
        type
        content
      }
      permissions
      previewVideo {
        id
        url
        blurhash
        title
        serviceImageThumbnail
        serviceVideoThumbnail
      }
      pageTemplate {
        id
        title
        templateName
      }
    }
  }
`;

export const GET_VIDEOS_MODULES = gql`
  query videosAdmin($filter: VideosFilter, $sort: VideosSort) {
    videosAdmin(filter: $filter, sort: $sort) {
      count
      videos {
        id
        title
        description
        createdAt
        isLive
        liveStatus
        imageThumbnail {
          url
          blurhash
        }
      }
    }
  }
`;
